import React, { Suspense, useState, useEffect, useRef } from "react";
import systemListingService from "./SystemListingServices";

export default function ContractStatus(param: any) {
  const [editingOn, setEditingOn] = useState(false);

  const [contractStatus, SetContractStatus] = useState<any>([]);

  useEffect(() => {

    if (param.activeTab === "Contract Status") {
      ContractStatusSelect()
    }
  }, [param])
  const ContractStatusSelect = () => {
    var payload = {}
    systemListingService.contractStatusList(payload).then((res:any) => { SetContractStatus(res) })
  }


  return (
    <div className="content-card ws-12">
      {/* Top edit tab */}
      <div className="ws-12 ptl pbl">
        <span className="text-bold">Contract Status</span>
        <button className={'icon-btn primary pull-right'} type="button" onClick={() => setEditingOn((prev) => !prev)}  >

          <span>{editingOn ? "Edit Mode: On" : "Edit Mode: Off"}</span>
        </button>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className={editingOn ? "editing-on newTable" : " newTable"}>
          <thead>
            <tr>
              <th >Contract ID</th>
              <th >Contract Status</th>
              <th >Account Summary</th>
              <th >Track Count</th>
              <th >EmailYN</th>
              <th style={{ width: "19%" }}>Operations</th>
            </tr>
          </thead>
          <tbody>
            {contractStatus.map((row: any) => (
              <tr key={row.id}>
                <td>{row.contractStatusId}</td>
                <td>
                  {row.statusName}
                </td>

                <td>
                  <div className={"pp-switch" + (row?.ignoreAccSummary === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.splitsTable === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.emailYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td width="15% !important" style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}  >
                  <div >
                    <button className={`btn-default ${row.isDefault ? "active" : ""}`} type="button" disabled={!editingOn}>
                      Default
                    </button>

                    <button className="icon-btn edit" type="button" disabled={!editingOn} >
                      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 20h9" />
                        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
                      </svg>
                    </button>

                    <button className="icon-btn delete" type="button" disabled={!editingOn}>
                      <i className="icon-trash"> </i>
                    </button>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add row + Save Changes button */}
      <div className="add-row-wrapper">
        <button id="addRowBtn" className="btn-add-row" type="button" disabled={!editingOn}>
          <svg
            width="19"
            height="19"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Add Contract Status
        </button>

        <button
          id="tableSaveBtn"
          className="btn-save-table"
          type="button"
          disabled={!editingOn}
          onClick={() => {
            setEditingOn(false);
          }}
        >
          Save Changes
        </button>
      </div>

    </div>
  );
};